import React from 'react'
import styled from 'styled-components'

import PasswordHideSrc from '../../../../../manager/images/pw-hide.svg'

const PasswordHide = styled.img`
  height: 22.5px;
  width: 22.5px;
  position: center;
  vertical-align: middle;
`
const PasswordHideIcon = () => (
    <PasswordHide src={PasswordHideSrc} />
)

export default PasswordHideIcon
